import { render, staticRenderFns } from "./BaseSectionSummary.vue?vue&type=template&id=3b5b04b1&scoped=true&"
import script from "./BaseSectionSummary.vue?vue&type=script&lang=js&"
export * from "./BaseSectionSummary.vue?vue&type=script&lang=js&"
import style0 from "./BaseSectionSummary.vue?vue&type=style&index=0&id=3b5b04b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5b04b1",
  null
  
)

export default component.exports